// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__qjPVe","wide":"style_wide__WtONH","grid":"style_grid__piEkS"};